<form
	class="ds-form"
	(ngSubmit)="onSubmit($event)">
	<div class="ds-status mb-4">
		<h3 class="ds-form__section-title">All with tooltip</h3>
		<div class="is-content-section mt-1 mb-5">
			<div class="is-content-section-fields">
				<eif-custom-input
					#input
					[label]="'Please enter your full name here'"
					[tooltip]="'Please enter your full name here'"
					[icon]="'fa-solid fa-info-circle'"
					[validationRules]="getValidationRules('input')"
					[fullWidth]="true"
					(valueChange)="onValueChange('input', $event)"
					(validationChange)="onValidationChange('input', $event)">
				</eif-custom-input>
				<eif-custom-select
					#select
					[label]="'Choose your preferred option from the dropdown menu'"
					[tooltip]="'Choose your preferred option from the dropdown menu'"
					[icon]="'fa-solid fa-info-circle'"
					[options]="selectOptions"
					[validationRules]="getValidationRules('select')"
					[fullWidth]="true"
					(valueChange)="onValueChange('select', $event)"
					(validationChange)="onValidationChange('select', $event)"
					[concatOptions]="true">
				</eif-custom-select>
				<eif-custom-date-picker
					#datePicker
					[label]="'Select your preferred meeting date'"
					[tooltip]="'Select your preferred meeting date'"
					[icon]="'fa-solid fa-info-circle'"
					[validationRules]="getValidationRules('datePicker')"
					[fullWidth]="true"
					(selectionChange)="onValueChange('datePicker', $event)"
					(validationChange)="onValidationChange('datePicker', $event)">
				</eif-custom-date-picker>
				<eif-custom-checkbox
					#checkbox
					[label]="'I agree to the terms and conditions of service'"
					[tooltip]="'I agree to the terms and conditions of service'"
					[icon]="'fa-solid fa-info-circle'"
					[checkedValue]="'Yes'"
					[uncheckedValue]="'No'"
					[validationRules]="getValidationRules('checkbox')"
					(checkedChange)="onValueChange('checkbox', $event)"
					(validationChange)="onValidationChange('checkbox', $event)">
				</eif-custom-checkbox>
				<eif-custom-switch
					#switch
					[label]="'Enable email notifications for important updates'"
					[tooltip]="'Enable email notifications for important updates'"
					[icon]="'fa-solid fa-info-circle'"
					[checkedValue]="'On'"
					[uncheckedValue]="'Off'"
					[validationRules]="getValidationRules('switch')"
					(switchChange)="onValueChange('switch', $event)"
					(validationChange)="onValidationChange('switch', $event)">
				</eif-custom-switch>
				<eif-custom-radio
					#radio
					[label]="'Allow for SMS push notifications'"
					[tooltip]="'Allow for SMS push notifications'"
					[icon]="'fa-solid fa-info-circle'"
					[options]="radioOptions"
					[validationRules]="getValidationRules('radio')"
					(valueChange)="onValueChange('radio', $event)"
					(validationChange)="onValidationChange('radio', $event)">
				</eif-custom-radio>
			</div>
		</div>
	</div>

	<div class="ds-status mb-4">
		<h3 class="ds-form__section-title">All with tooltip and readonly</h3>
		<div class="is-content-section mt-1 mb-5">
			<div class="is-content-section-fields">
				<eif-custom-input
					#inputReadonly
					[readonlyValue]="true"
					[label]="'Please enter your full name here'"
					[tooltip]="'Please enter your full name here'"
					[icon]="'fa-solid fa-info-circle'"
					[validationRules]="getValidationRules('inputReadonly')"
					[fullWidth]="true"
					(valueChange)="onValueChange('inputReadonly', $event)"
					(validationChange)="onValidationChange('inputReadonly', $event)">
				</eif-custom-input>
				<eif-custom-select
					#selectReadonly
					[readonlyValue]="true"
					[label]="'Choose your preferred option from the dropdown menu'"
					[tooltip]="'Choose your preferred option from the dropdown menu'"
					[icon]="'fa-solid fa-info-circle'"
					[options]="selectOptions"
					[validationRules]="getValidationRules('selectReadonly')"
					[fullWidth]="true"
					(valueChange)="onValueChange('selectReadonly', $event)"
					(validationChange)="onValidationChange('selectReadonly', $event)"
					[concatOptions]="true">
				</eif-custom-select>
				<eif-custom-date-picker
					#datePickerReadonly
					[readonlyValue]="true"
					[label]="'Select your preferred meeting date'"
					[tooltip]="'Select your preferred meeting date'"
					[icon]="'fa-solid fa-info-circle'"
					[validationRules]="getValidationRules('datePickerReadonly')"
					[fullWidth]="true"
					(selectionChange)="onValueChange('datePickerReadonly', $event)"
					(validationChange)="onValidationChange('datePickerReadonly', $event)">
				</eif-custom-date-picker>
				<eif-custom-checkbox
					#checkboxReadonly
					[readonlyValue]="true"
					[label]="'I agree to the terms and conditions of service'"
					[tooltip]="'I agree to the terms and conditions of service'"
					[icon]="'fa-solid fa-info-circle'"
					[checkedValue]="'Yes'"
					[uncheckedValue]="'No'"
					[validationRules]="getValidationRules('checkboxReadonly')"
					(checkedChange)="onValueChange('checkboxReadonly', $event)"
					(validationChange)="onValidationChange('checkboxReadonly', $event)">
				</eif-custom-checkbox>
				<eif-custom-switch
					#switchReadonly
					[readonlyValue]="true"
					[label]="'Enable email notifications for important updates'"
					[tooltip]="'Enable email notifications for important updates'"
					[icon]="'fa-solid fa-info-circle'"
					[checkedValue]="'On'"
					[uncheckedValue]="'Off'"
					[validationRules]="getValidationRules('switchReadonly')"
					(switchChange)="onValueChange('switchReadonly', $event)"
					(validationChange)="onValidationChange('switchReadonly', $event)">
				</eif-custom-switch>
				<eif-custom-radio
					#radioReadonly
					[readonlyValue]="true"
					[label]="'Allow for SMS push notifications'"
					[tooltip]="'Allow for SMS push notifications'"
					[icon]="'fa-solid fa-info-circle'"
					[name]="'radio-group-readonly'"
					[options]="radioOptions"
					[validationRules]="getValidationRules('radioReadonly')"
					(valueChange)="onValueChange('radioReadonly', $event)"
					(validationChange)="onValidationChange('radioReadonly', $event)">
				</eif-custom-radio>
			</div>
		</div>
	</div>

	<div class="d-flex gap-2 justify-content-between">
		<div class="d-flex gap-2">
			<eif-custom-button
				[text]="'Clear Form'"
				[variant]="'outlined'"
				[color]="'neutral'"
				(click)="resetForm()">
			</eif-custom-button>
			<eif-custom-button
				[text]="'Fill Forms'"
				(click)="fillForm()">
			</eif-custom-button>
		</div>
		<eif-custom-button
			[text]="'Submit'"
			[loading]="isValidating"
			[disabled]="!isFormValid"
			(click)="validateForm()">
		</eif-custom-button>
	</div>
</form>
